import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { clientsAPI } from "../services/api";
import BillingConditionsDetails from "./BillingConditionsDetails";

export default function BillingSummary({ clientId, subscription = false }) {
  const [result, setResult] = useState(null);
  useEffect(() => {
    let active = true;
    setResult(null);
    if (clientId) clientsAPI.billing(clientId).then(({ data }) => {
      if (active) setResult({ clientId, data });
    }).catch((error) => {
      if (active) setResult({ clientId, error: error?.response?.data?.detail || "Conditions indisponibles" });
    });
    return () => { active = false; };
  }, [clientId]);
  if (!clientId) return null;
  if (!result || result.clientId !== clientId) return <p className="text-sm text-gray-500">Chargement des conditions...</p>;
  if (result.error) return <div role="alert" className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
    <p>{result.error}</p>
    <Link to="/clients" className="underline">Vérifier la fiche client</Link>
  </div>;
  const terms = result.data;
  const today = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
  const due = new Date(`${today}T12:00:00Z`);
  due.setUTCDate(due.getUTCDate() + terms.delai_paiement);
  return <div className="rounded-lg border border-primary-100 bg-primary-50 p-4 text-sm text-gray-700 space-y-2">
    <h3 className="font-semibold text-gray-900">Conditions de facturation du client</h3>
    <BillingConditionsDetails terms={terms} mentions={terms.mentions} />
    {!subscription && <p>Échéance {due.toLocaleDateString("fr-FR", { timeZone: "UTC" })} pour une émission aujourd'hui.</p>}
    <p className="text-xs text-gray-500">Ces conditions seront conservées sur le document. Les prix des lignes restent modifiables avant émission.</p>
  </div>;
}
